import http from "@/api/http.js";

export function createDispatchReceipt(orderUUID) {
  return http.post("/order_receipts", { order_uuid: orderUUID }).then(res => {
    return res.data;
  });
}

export function getDispatchReceipt(receiptId) {
  return http.get(`/order_receipts/single/${receiptId}`).then(res => {
    return res.data;
  });
}

export function deleteDispatchReceipt(orderUUID) {
  return http.delete(`/order_receipts/${orderUUID}`).then(res => {
    return res.data;
  });
}

export function deleteDispatchReceiptItem(itemId) {
  return http.delete(`/order_receipts/item/${itemId}`).then(res => {
    return res.data;
  });
}

export function addItemToDispatchReceipt(receiptId, item) {
  return http
    .post(`/order_receipts/item`, {
      receipt_id: receiptId,
      box_type: item.type,
      box_weight: item.weight,
      box_length: item.length,
      box_width: item.width,
      box_height: item.height,
      quantity: item.quantity,
      notes: item.notes
    })
    .then(res => {
      return res.data;
    });
}

export function removeItemFromDispatchReceipt(orderUUID, itemUUID) {
  return http
    .delete(`/order_receipts/${orderUUID}/items/${itemUUID}`)
    .then(res => {
      return res.data;
    });
}

export function updateItemInDispatchReceipt(orderUUID, itemUUID, item) {
  return http
    .put(`/order_receipts/${orderUUID}/items/${itemUUID}`, { item })
    .then(res => {
      return res.data;
    });
}

export function updateDispatchReceipt(receiptId, receipt) {
  const params = {
    receiver_infoauto_id: receipt.receiverInfoautoId,
    receiver_infoauto_address: receipt.receiverInfoautoAddress,
    receiver_infoauto_name: receipt.receiverInfoautoName,
    receiver_infoauto_email: receipt.receiverInfoautoEmail,
    receiver_infoauto_phone: receipt.receiverInfoautoPhone,
    destination_customer_infoauto_id: receipt.destinationCustomerInfoautoId,
    destination_customer_infoauto_address:
      receipt.destinationCustomerInfoautoAddress,
    destination_customer_infoauto_name: receipt.destinationCustomerInfoautoName,
    destination_customer_infoauto_email:
      receipt.destinationCustomerInfoautoEmail,
    destination_customer_infoauto_phone:
      receipt.destinationCustomerInfoautoPhone,
    status: receipt.status,
    condition: receipt.condition
  };
  console.log({ params });
  return http
    .put(`/order_receipts/receipt/${receiptId}`, { receipt: params })
    .then(res => {
      return res.data;
    });
}
